export function pxToRem(pxValue, theme) {
  return pxValue / theme.Typography.DEFAULT_FONT_SIZE.p[0];
}